import label from './bar.data.emphasis.label'
import itemStyle from './bar.data.emphasis.itemStyle'

export default {
  name: "emphasis",
  nickname: "高亮",
  desc: "高亮状态的柱状图图形与标签样式。",
  type: "object",
  props: {
    label,
    itemStyle,
  },
}
